import React from "react";

const PrizeDist = () => {
  return (
    <div>
      <div className="heading_box" style={{ marginBottom: "5%" }}>
        <div>
          <p class="btn">
            <span>
              <span>
                <span className="border_box">Prize Distribution</span>
              </span>
            </span>
          </p>
        </div>
        <app-prizes className="ng-star-inserted">
          <div className="d-flex d_flex ng-star-inserted">
            <div className="row">
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    1st Team Prize{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    KodeClippers{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    40,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/deep-sekhar/HackAnIntern"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              {/**/}
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className=" heading ng-star-inserted"
                  >
                    {" "}
                    First Runner Up{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    Sentinel Stars{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    20,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/chan27-2/stock-auction.git"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              <div className="item ng-star-inserted last">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    Second Runner Up{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    it_works_on_local{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    15,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/hack-an-intern"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              {/**/}
              {/**/}
              {/**/}
            </div>
            <div className="row">
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    4th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    Gigabyte{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    10,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/umang-singla/Gigabyte"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    5th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    Chainbreakers{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    10,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/leader282/ChainBreakers.git"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              <div className="item ng-star-inserted last">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    6th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    Brute Force{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    4,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/NishakarKT/kodein"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              {/**/}
            </div>
            <div className="row">
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    7th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    {"< akatsuki />"}{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    4,000{" "}
                  </strong>
                  <a
                    className="link1"
                    href="https://github.com/the-halfbloodprince/kodeinkgp_hackathon_server"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Server Link
                  </a>
                  <span>|</span>
                  <a
                    className="link2"
                    href="https://github.com/the-halfbloodprince/kodeinkgp_hackathon_client"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Client Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    8th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    Kaizen{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    4,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/be-u-nik/kodeinkgp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              <div className="item ng-star-inserted last">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    9th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    HashRed{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    4,000{" "}
                  </strong>
                  <a
                    className="link3"
                    href="https://github.com/Astound/hack-an-intern-frontend"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Frontend
                  </a>
                  <span>|</span>
                  <a
                    className="link2"
                    href="https://github.com/Astound/hack-an-intern-backend"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Backend
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              {/**/}
            </div>
            <div className="row">
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    10th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    FlexBox{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    4,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/Ketan-Ag/density-hack-an-intern-flexbox.git"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    11th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    Kabila{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    3,000{" "}
                  </strong>
                  <a
                    className="link3"
                    href="https://github.com/thewhitewolf09/stockup.git"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Frontend
                  </a>
                  <span>|</span>
                  <a
                    className="link2"
                    href="https://github.com/thewhitewolf09/stock_up-server.git"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Backend
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              <div className="item ng-star-inserted last">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    12th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4
                    _ngcontent-d2c-frontend-c160=""
                    className="team_name"
                  >
                    {" "}
                    Crashed API{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    3,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="https://github.com/AryanJ13/KodeInKgp_Hackthon"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              {/**/}
            </div>
            <div className="row">
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    13th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    Genesis{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    3,000{" "}
                  </strong>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              <div className="item ng-star-inserted">
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h3
                    _ngcontent-d2c-frontend-c160=""
                    className="heading ng-star-inserted"
                  >
                    {" "}
                    14th Position{" "}
                  </h3>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div _ngcontent-d2c-frontend-c160="" className="full-width">
                  <h4 className="team_name">
                    {" "}
                    Devstars{" "}
                  </h4>
                  {/**/}
                  {/**/}
                  {/**/}
                </div>
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="trophy ng-star-inserted"
                >
                  <strong _ngcontent-d2c-frontend-c160="" className="blue-text">
                    <em
                      _ngcontent-d2c-frontend-c160=""
                      aria-hidden="true"
                      className="fa fa-rupee"
                    />{" "}
                    3,000{" "}
                  </strong>
                  <a
                    className="link"
                    href="http://github.com/Greeshraj/Hackanintern"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Link
                  </a>
                </div>
                {/**/}
                <img
                  _ngcontent-d2c-frontend-c160=""
                  src="https://d8it4huxumps7.cloudfront.net/uploads/images/svg-images/unstop-trophy.png"
                  alt="Trophy Icon"
                  width={78}
                  height={78}
                  className="trophy_icon ng-star-inserted"
                />
                {/**/}
                {/**/}
                <div
                  _ngcontent-d2c-frontend-c160=""
                  className="certificate ng-star-inserted"
                >
                  {" "}
                  Certificate{" "}
                </div>
                {/**/}
                {/**/}
                {/**/}
              </div>
              {/**/}
            </div>
          </div>
        </app-prizes>
      </div>
      <div>
        <h1
          style={{
            width: "100%",
            textAlign: "center",
            marginBottom: "2%",
            marginTop: "30px",
            fontSize: "1.4rem",
          }}
          className="page3_subtitle text3"
        >
          ***And many more exciting Goodies and Participation Certificate
        </h1>
      </div>
    </div>
  );
};

export default PrizeDist;
